import { useActivityTracker } from '@/hooks/useActivityTracker';

// Component to track user activity
const ActivityTracker = () => {
  useActivityTracker();
  return null;
};

export default ActivityTracker;
